import { defineBlock, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Site Footer",
  description: "The footer of the site",
  icon: "hammer",
}

export default defineBlock("parts/part-site-footer", (props) => {
  return (
    <InnerBlocks
      allowedBlocks={["footer/footer"]}
      template={[["footer/footer", {}]]}
      templateLock="all"
      orientation="vertical"
    />
  )
})
